export const getAvatarInitials = (name?: string | null, fallback?: string | null): string => {
  const cleaned = name?.trim() ?? "";
  if (cleaned) {
    const parts = cleaned.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      const first = parts[0][0] ?? "";
      const last = parts[parts.length - 1][0] ?? "";
      return `${first}${last}`.toUpperCase();
    }
    return parts[0].slice(0, 2).toUpperCase();
  }

  const fallbackToken = fallback?.split("@")[0]?.trim() ?? "";
  if (fallbackToken) {
    return fallbackToken.slice(0, 2).toUpperCase();
  }

  return "?";
};
